import SolicitaCredito from './SolicitaCredito';
export default SolicitaCredito;
